import { Component, Input, OnInit } from '@angular/core';
import { BaseTest } from 'src/app/models/test.model';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  @Input() test: BaseTest;
  @Input() subTitle: string;

  constructor() { }

  ngOnInit(): void {
  }

}
